/**
 * Адрес страницы съёмки публичного плеера службой разбора (WEB-3913) — для
 * маршрута публичного входа (`router/publicRouter.tsx`). Отдельным модулем,
 * чтобы маршрут не тянул в первый экран обычной воронки модуль режима съёмки
 * (`player/shootMode.ts`, лежит в ленивом куске страницы съёмки).
 */
export const SHOOT_PAGE_PATH = '/__shoot';
